


































































import EditionModal from "../core/Modals/EditionModal.vue";
import { FactureFournisseurApi } from "../api/FactureFournisseurApi";
import { FactureFournisseur } from "../models/FactureFournisseur";
import { UserApi } from "../api/UserApi";
import { User } from "../models/User";
import FactureFournisseurModalEdit from "./FactureFournisseurModalPartials/FactureFournisseurModalEdit.vue";
import FactureFournisseurModalDisplay from "./FactureFournisseurModalPartials/FactureFournisseurModalDisplay.vue";
import FactureFournisseurModalPdfViewer from "./FactureFournisseurModalPartials/FactureFournisseurModalPdfViewer.vue";

export default {
    name: "FactureFournisseurModal",
    components: {
        EditionModal,
        FactureFournisseurModalEdit,
        FactureFournisseurModalDisplay,
        FactureFournisseurModalPdfViewer,
    },
    props: {
        factureFournisseurId: Number,
        isNew: Boolean,
        forceEditing: Boolean,
    },
    data() {
        return {
            showModal: false,
            factureFournisseur: null,
            fetching: true,
            editing: false,
            FactureFournisseurApi: new FactureFournisseurApi(),
            UserApi: new UserApi(),
            editable: true,
            showPdfInEditMode: false,
        };
    },
    created() {
        var self = this;

        self.UserApi.getCurrentUser().then(function (user) {
            self.editable = !user.hasRole(User.ERole.Syndic);
        });
    },
    watch: {
        factureFournisseurId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.FactureFournisseurApi.get(self.factureFournisseurId, {
                    include: "files,client",
                }).then(function (res) {
                    self.factureFournisseur = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.factureFournisseur = new FactureFournisseur({});
                    this.creationModal();
                }
            },
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.editing = false;
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveFactureFournisseur: function (): Promise<FactureFournisseur> {
            var self = this;
            return self.FactureFournisseurApi.save(
                self.factureFournisseur
            ).then(function (res) {
                self.$emit("data-saved", self.factureFournisseur);
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        togglePdfVisibility: function (): void {
            this.showPdfInEditMode = !this.showPdfInEditMode;
        },
    },
};
